// extracted by mini-css-extract-plugin
export default {"root":"portfolio_root__5S9cS","illustrate":"portfolio_illustrate__p3dkO","header":"portfolio_header__46XGt","section":"portfolio_section__byoKI"};